// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-container {
  margin-top: 5%;
  display: grid;
  grid-template-columns: 23% 23% 23%;
  gap: 10%;
  grid-row-gap: 40px;
  justify-content: center;
  /* margin-left: 60px; */
  /* margin-bottom: 50px; */
}

.top-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* row-gap: 2%; */
  /* justify-content: space-evenly; */
  /* padding: 10px 10px; */
  height: 12vh;
  background-color: rgb(238, 238, 238);
  /* border: none; */
  border-radius: 10px;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.icondiv {
  box-sizing: border-box;
  border: 1px solid black;
}
.top-button img {
  /* margin-right: 10px; */
  width: 40px;
  height: 40px;
}

.top-button:hover {
  /* color: white; */
  box-shadow: 0px 2px 4px 4px rgba(0, 0, 0, 0.2);
  /* border: 2px solid rgb(75, 173, 234); */
  /* background-color: rgb(8, 8, 8); */
  /* z-index: 1; */
}

/* .top-button:hover::before {
  content: "";
  position: absolute;
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
  border: 2px solid rgb(126, 125, 125);
  border-radius: 10px;
  color: red !important;
} */

.s3Bucketfields {
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 30px;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 20px;
}

.metaBucketfields {
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 30px;
  justify-content: center;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-right: 120px;
  width: 90%;
}

.Heading {
  margin-right: 60%;
}

.Heading1 {
  display: flex;
  align-items: center;
}

.s3Bucketlogo {
  width: 50px;
  height: auto;
  margin-right: 10px;
  max-height: 100%;
  object-fit: contain;
}

.RDBMSlogo {
  width: 50px;
  height: auto;
  margin-right: 10px;
  max-height: 100%;
  object-fit: contain;
}

.sourcetargetbutton {
  text-align: center;
  background-color: #8b5ccc;
  color: white;
  border: none;
  padding: 10px 40px;
  font-size: 20px;
  margin-bottom: 30px;
  border-radius: 5px;
}

.sourcetargetbutton:hover {
  background-color: rgba(54, 3, 125, 0.919);
  color: white;
}

.fieldbutton {
  display: flex;
  padding: 10px;
  grid-column-gap: 50px;
  margin-left: 30px;
}

.mainHeading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* height: 6vh !important; */
  /* padding: 30px;
  grid-template-columns: 40% 40%; */
}

.checkboxfields {
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 20px;
  margin-top: 20px;
  margin-right: 150px;
}

.radioinputfields {
  display: grid;
  grid-row-gap: 20px;
  margin-right: 240px;
}

.RDBMSfields {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 70px;
  grid-row-gap: 30px;
  justify-content: center;
  margin-bottom: 30px;
  margin-left: 80px;
  padding-right: 50px;
}

.RDBMSformLayout {
  /* padding-right: 50px; */
  /* margin-right: 100px; */
  /* background-color: blue; */
}

.PostgreSqllogo {
  width: 55px;
  height: auto;
  /* margin-right: 10px; */
  max-height: 100%;
  object-fit: contain;
}

.RDBMSHeading {
  /* background-color: red; */
  width: 100% !important;
  padding: 7px 0px;
  padding-left: 20px;
  /* box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2); */
  /* box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25); */
  /* box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.25); */
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 1px;
}

.RDBMSHeading1 {
  display: flex;
  align-items: center;
}

.Sqllogo {
  width: 55px;
  height: auto;
  max-height: 100%;
  object-fit: contain;
}

.oraclelogo {
  width: 55px;
  height: auto;
  /* margin-right: 5px; */
  max-height: 100%;
  object-fit: contain;
}

.RDBMSbutton {
  text-align: center;
  background-color: #8b5ccc;
  color: white;
  border: none;
  padding: 10px 40px;
  font-size: 20px;
  margin-bottom: 30px;
  border-radius: 5px;
  margin-right: 10px;
}

.RDBMSbutton:hover {
  background-color: rgba(54, 3, 125, 0.919);
  color: white;
}

.RDBMSfieldbutton {
  display: flex;
  padding: 10px;
  margin-left: 120px;
  grid-column-gap: 40px;
}

.radiobutton {
  display: flex;
  padding: 10px;
  margin-top: 20px;
  grid-column-gap: 30px;
  justify-content: center;
  margin-left: 10px;
}

.radiofields {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 50% 50%;
  grid-column-gap: 70px;
  grid-row-gap: 30px;
  padding: 10px;
  justify-content: center;
  margin-bottom: 30px;
  margin-left: 120px;
}

.radiofields1 {
  /* margin-top: 40px; */
  margin-left: 90px;
  margin-bottom: 20px;
  width: 50%;
}

.mainformlayout {
  display: center;
  justify-content: center;
  align-items: center;
  height: 60vh;
  padding-left: 215px;
  padding-right: 220px;
  /* overflow-y: hidden;
  overflow-x: hidden; */
}

.cardlayout {
  position: relative;
  background-color: #fff;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.2);
  padding: 20px;
  border-radius: 10px;
  margin-top: 50px;
  top: 20%;
  left: 8%;
  /* height: 60vh; */
  width: 80%;
}

.s3radiobutton {
  display: flex;
  grid-column-gap: 10px;
  justify-content: center;
}

.postgresqlcheckboxfields {
  display: grid;
  grid-row-gap: 20px;
  margin-top: 24px;
  margin-left: 45px;
  margin-bottom: 30px;
}

.SQLcheckboxfields {
  display: grid;
  grid-row-gap: 20px;
  margin-top: 50px;
  margin-left: 90px;
  margin-bottom: 30px;
}

.Oraclecheckboxfields {
  display: grid;
  grid-row-gap: 20px;
  margin-top: 50px;
  margin-left: 90px;
  margin-bottom: 30px;
}

.s3radio {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

label {
  margin-bottom: 0px !important;
}

.activepath {
  /* color: white; */
  box-shadow: 0px 0.5px 4px 6px rgba(32, 32, 32, 0.2);
  border: 1px solid rgb(39, 38, 38) !important;
  /* background-color: black !important; */
  /* color: white !important; */
  /* font-size: 10rem; */
}

.card-background {
  height: 79vh;
  margin-top: 5vh;
  /* background-image: url("../../../assets/backgroung.avif");
  background-size: cover;
  background-position: center; */
}

.extractOptions {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 7vh;
  border-radius: 10px 10px 0px 0px;
  /* background-color: rgb(139, 188, 230); */
  /* background-color: rgb(203, 192, 219); */
  background-color: whitesmoke;
}

.extractOptionsContent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 5vh;
  background-color: white;
  border-radius: 0px 0px 10px 10px;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/etlModule/extractload/extractload.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;EACnC,wBAAwB;EACxB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,yCAAyC;EACzC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B;mCACiC;AACnC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,iDAAiD;EACjD,kDAAkD;EAClD,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB;uBACqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;EACR,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;EACnD,4CAA4C;EAC5C,wCAAwC;EACxC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf;;gCAE8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,0CAA0C;EAC1C,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;AACnB","sourcesContent":[".button-container {\n  margin-top: 5%;\n  display: grid;\n  grid-template-columns: 23% 23% 23%;\n  gap: 10%;\n  grid-row-gap: 40px;\n  justify-content: center;\n  /* margin-left: 60px; */\n  /* margin-bottom: 50px; */\n}\n\n.top-button {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  /* row-gap: 2%; */\n  /* justify-content: space-evenly; */\n  /* padding: 10px 10px; */\n  height: 12vh;\n  background-color: rgb(238, 238, 238);\n  /* border: none; */\n  border-radius: 10px;\n  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n}\n.icondiv {\n  box-sizing: border-box;\n  border: 1px solid black;\n}\n.top-button img {\n  /* margin-right: 10px; */\n  width: 40px;\n  height: 40px;\n}\n\n.top-button:hover {\n  /* color: white; */\n  box-shadow: 0px 2px 4px 4px rgba(0, 0, 0, 0.2);\n  /* border: 2px solid rgb(75, 173, 234); */\n  /* background-color: rgb(8, 8, 8); */\n  /* z-index: 1; */\n}\n\n/* .top-button:hover::before {\n  content: \"\";\n  position: absolute;\n  top: -6px;\n  left: -6px;\n  right: -6px;\n  bottom: -6px;\n  border: 2px solid rgb(126, 125, 125);\n  border-radius: 10px;\n  color: red !important;\n} */\n\n.s3Bucketfields {\n  display: grid;\n  grid-template-columns: 100%;\n  grid-row-gap: 30px;\n  justify-content: center;\n  margin-top: 30px;\n  margin-bottom: 20px;\n}\n\n.metaBucketfields {\n  display: grid;\n  grid-template-columns: 100%;\n  grid-row-gap: 30px;\n  justify-content: center;\n  margin-top: 30px;\n  margin-bottom: 30px;\n  margin-right: 120px;\n  width: 90%;\n}\n\n.Heading {\n  margin-right: 60%;\n}\n\n.Heading1 {\n  display: flex;\n  align-items: center;\n}\n\n.s3Bucketlogo {\n  width: 50px;\n  height: auto;\n  margin-right: 10px;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.RDBMSlogo {\n  width: 50px;\n  height: auto;\n  margin-right: 10px;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.sourcetargetbutton {\n  text-align: center;\n  background-color: #8b5ccc;\n  color: white;\n  border: none;\n  padding: 10px 40px;\n  font-size: 20px;\n  margin-bottom: 30px;\n  border-radius: 5px;\n}\n\n.sourcetargetbutton:hover {\n  background-color: rgba(54, 3, 125, 0.919);\n  color: white;\n}\n\n.fieldbutton {\n  display: flex;\n  padding: 10px;\n  grid-column-gap: 50px;\n  margin-left: 30px;\n}\n\n.mainHeading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  /* height: 6vh !important; */\n  /* padding: 30px;\n  grid-template-columns: 40% 40%; */\n}\n\n.checkboxfields {\n  display: grid;\n  grid-template-columns: 100%;\n  grid-row-gap: 20px;\n  margin-top: 20px;\n  margin-right: 150px;\n}\n\n.radioinputfields {\n  display: grid;\n  grid-row-gap: 20px;\n  margin-right: 240px;\n}\n\n.RDBMSfields {\n  margin-top: 20px;\n  display: grid;\n  grid-template-columns: 50% 50%;\n  grid-column-gap: 70px;\n  grid-row-gap: 30px;\n  justify-content: center;\n  margin-bottom: 30px;\n  margin-left: 80px;\n  padding-right: 50px;\n}\n\n.RDBMSformLayout {\n  /* padding-right: 50px; */\n  /* margin-right: 100px; */\n  /* background-color: blue; */\n}\n\n.PostgreSqllogo {\n  width: 55px;\n  height: auto;\n  /* margin-right: 10px; */\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.RDBMSHeading {\n  /* background-color: red; */\n  width: 100% !important;\n  padding: 7px 0px;\n  padding-left: 20px;\n  /* box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2); */\n  /* box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25); */\n  /* box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.25); */\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 1px;\n}\n\n.RDBMSHeading1 {\n  display: flex;\n  align-items: center;\n}\n\n.Sqllogo {\n  width: 55px;\n  height: auto;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.oraclelogo {\n  width: 55px;\n  height: auto;\n  /* margin-right: 5px; */\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.RDBMSbutton {\n  text-align: center;\n  background-color: #8b5ccc;\n  color: white;\n  border: none;\n  padding: 10px 40px;\n  font-size: 20px;\n  margin-bottom: 30px;\n  border-radius: 5px;\n  margin-right: 10px;\n}\n\n.RDBMSbutton:hover {\n  background-color: rgba(54, 3, 125, 0.919);\n  color: white;\n}\n\n.RDBMSfieldbutton {\n  display: flex;\n  padding: 10px;\n  margin-left: 120px;\n  grid-column-gap: 40px;\n}\n\n.radiobutton {\n  display: flex;\n  padding: 10px;\n  margin-top: 20px;\n  grid-column-gap: 30px;\n  justify-content: center;\n  margin-left: 10px;\n}\n\n.radiofields {\n  margin-top: 20px;\n  display: grid;\n  grid-template-columns: 50% 50%;\n  grid-column-gap: 70px;\n  grid-row-gap: 30px;\n  padding: 10px;\n  justify-content: center;\n  margin-bottom: 30px;\n  margin-left: 120px;\n}\n\n.radiofields1 {\n  /* margin-top: 40px; */\n  margin-left: 90px;\n  margin-bottom: 20px;\n  width: 50%;\n}\n\n.mainformlayout {\n  display: center;\n  justify-content: center;\n  align-items: center;\n  height: 60vh;\n  padding-left: 215px;\n  padding-right: 220px;\n  /* overflow-y: hidden;\n  overflow-x: hidden; */\n}\n\n.cardlayout {\n  position: relative;\n  background-color: #fff;\n  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.2);\n  padding: 20px;\n  border-radius: 10px;\n  margin-top: 50px;\n  top: 20%;\n  left: 8%;\n  /* height: 60vh; */\n  width: 80%;\n}\n\n.s3radiobutton {\n  display: flex;\n  grid-column-gap: 10px;\n  justify-content: center;\n}\n\n.postgresqlcheckboxfields {\n  display: grid;\n  grid-row-gap: 20px;\n  margin-top: 24px;\n  margin-left: 45px;\n  margin-bottom: 30px;\n}\n\n.SQLcheckboxfields {\n  display: grid;\n  grid-row-gap: 20px;\n  margin-top: 50px;\n  margin-left: 90px;\n  margin-bottom: 30px;\n}\n\n.Oraclecheckboxfields {\n  display: grid;\n  grid-row-gap: 20px;\n  margin-top: 50px;\n  margin-left: 90px;\n  margin-bottom: 30px;\n}\n\n.s3radio {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\nlabel {\n  margin-bottom: 0px !important;\n}\n\n.activepath {\n  /* color: white; */\n  box-shadow: 0px 0.5px 4px 6px rgba(32, 32, 32, 0.2);\n  border: 1px solid rgb(39, 38, 38) !important;\n  /* background-color: black !important; */\n  /* color: white !important; */\n  /* font-size: 10rem; */\n}\n\n.card-background {\n  height: 79vh;\n  margin-top: 5vh;\n  /* background-image: url(\"../../../assets/backgroung.avif\");\n  background-size: cover;\n  background-position: center; */\n}\n\n.extractOptions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 7vh;\n  border-radius: 10px 10px 0px 0px;\n  /* background-color: rgb(139, 188, 230); */\n  /* background-color: rgb(203, 192, 219); */\n  background-color: whitesmoke;\n}\n\n.extractOptionsContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 5vh;\n  background-color: white;\n  border-radius: 0px 0px 10px 10px;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
